import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import type { BaseActions, BaseState } from '../interfaces'

import { StoreDevtoolsName } from './store-names.const'

interface BaseStore extends BaseState, BaseActions {}

export function createBaseStore(appName: string) {
  const defaultValues: BaseState = {
    appName,
    visits: 0,
  }

  return create<BaseStore>()(
    devtools(
      (set) => {
        const actions: BaseActions = {
          increase: (by) => set((state) => ({ visits: state.visits + by })),
        }

        return {
          ...defaultValues,
          ...actions,
        }
      },
      {
        name: StoreDevtoolsName.BaseStore,
        enabled: process.env.NODE_ENV === 'development',
      }
    )
  )
}
